export default __webpack_public_path__ + "static/media/mail.2f20e955.svg";